import colors from 'shared-assets/lib/colors';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import styles from 'shared-assets/lib/styles';

import Checkbox from './Checkbox';
import Radio from './Radio';

const InputStyled = styled.input`
  width: 100%;
  height: 2rem;
  border-radius: ${styles.borderRadius};
  border: ${styles.border.default};
  outline: none;
  font-size: 1rem;
  line-height: 1.5rem;
  padding: ${styles.padding};
  color: ${colors.secondary};

  &:placeholder {
    color: ${colors.light};
  }

  &:focus {
    border: ${styles.border.focus};
  }

  &:required:invalid {
    border-color: ${props => props.invalidColor};
  }

  &:disabled {
    color: ${colors.light};
  }
`;

InputStyled.defaultProps = {
  status: undefined,
};

InputStyled.propTypes = {
  status: PropTypes.oneOf(['error']),
};

export default class Input extends React.Component {
  static defaultProps = {
    inputRef: undefined,
    onBlur: undefined,
    type: 'text',
    visited: false,
  };
  static propTypes = {
    inputRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({
        current: PropTypes.instanceOf(HTMLInputElement),
      }),
    ]),
    onBlur: PropTypes.func,
    type: PropTypes.oneOf([
      'date',
      'text',
      'number',
      'checkbox',
      'checkboxasradio',
      'email',
      'radio',
      'hidden',
    ]),
    visited: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = { visited: false };
  }

  onBlur = event => {
    this.setState({ visited: true });
    if (!!this.props.onBlur && typeof this.props.onBlur === 'function') {
      this.props.onBlur(event);
    }
  };

  render() {
    const { inputRef, type, onBlur, visited, ...rest } = this.props;
    let output = (
      <InputStyled
        type={type}
        onBlur={this.onBlur}
        invalidColor={this.state.visited && colors.error}
        {...rest}
        ref={inputRef}
      />
    );

    if (type === 'checkbox') {
      output = <Checkbox ref={inputRef} type={type} {...rest} />;
    }
    if (type === 'checkboxasradio') {
      output = <Checkbox ref={inputRef} type="radio" {...rest} />;
    }
    if (type === 'radio') {
      output = <Radio ref={inputRef} type={type} {...rest} />;
    }
    if (type === 'hidden') {
      output = <input ref={inputRef} type={type} {...rest} />;
    }
    return output;
  }
}
